import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Trigger animation after component mounts
    setIsVisible(true);
  }, []);
  return <section id="hero" className="w-full bg-black text-white relative" style={{
    backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/mcvhPruo8YvTyLQsUeQqPN/vecteezy_binary-fusion-monochromatic-tech-graphic-background_27180311.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh'
  }} data-id="element-152">
      <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-153"></div>
      <div className="container mx-auto px-4 py-32 md:py-48 flex flex-col items-center justify-center text-center relative z-10 min-h-[90vh]" data-id="element-154">
        <h1 className="text-5xl md:text-7xl font-extrabold mb-8 leading-tight overflow-hidden" data-id="element-155">
          <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
          transitionDelay: '200ms'
        }} data-id="element-156">
            <span className="text-red-600 inline-block hover:scale-105 transition-transform duration-300" data-id="element-157">
              INNOVATIVE
            </span>{' '}
            TECH
          </div>
          <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
          transitionDelay: '600ms'
        }} data-id="element-158">
            <span className="text-red-600 inline-block hover:scale-105 transition-transform duration-300" data-id="element-159">
              SOLUTIONS
            </span>{' '}
            FOR THE
          </div>
          <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
          transitionDelay: '1000ms'
        }} data-id="element-160">
            <span className="text-red-600 inline-block hover:scale-105 transition-transform duration-300" data-id="element-161">
              DIGITAL
            </span>{' '}
            AGE
          </div>
        </h1>
        <p className={`text-xl md:text-2xl text-gray-300 max-w-xl mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`} style={{
        transitionDelay: '1400ms'
      }} data-id="element-162">
          Transforming businesses through cutting-edge technology and security
          solutions.
        </p>
        <Link to="/get-quote" className={`bg-red-600 hover:bg-red-700 text-white px-10 py-4 rounded-md font-bold flex items-center justify-center transition-all duration-500 text-xl shadow-lg ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
        transitionDelay: '1800ms'
      }} data-id="element-163">
          Start a Free Assessment <ArrowRightIcon className="ml-2 h-6 w-6" data-id="element-164" />
        </Link>
      </div>
    </section>;
};